import { render, staticRenderFns } from "./InputTabSelect.vue?vue&type=template&id=20c36ebe&scoped=true&"
import script from "./InputTabSelect.vue?vue&type=script&lang=ts&"
export * from "./InputTabSelect.vue?vue&type=script&lang=ts&"
import style0 from "./InputTabSelect.vue?vue&type=style&index=0&id=20c36ebe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c36ebe",
  null
  
)

export default component.exports